import { Route, Routes } from 'react-router-dom'
import Error404 from '../../pages/Error404'
import CandiContact from './CandiContact'
import CandidateDashboard from './CandidateDashboard'
import CandidateJobs from './CandidateJobs'
import CandidatesCompanies from './CandidatesCompanies'
import ComingSoon from './ComingSoon'
import CompamyPage from './CompanyPage'
import DreamCompany from './DreamCompany'
import DreamJob from './DreamJob'
import JobDescription from './JobDescription'
import Jobpreference from './jobpreference/Jobpreference'
import JobPreferences from './JobPreferences'
import MyApplication from './MyApplication'
import Payment from './Payment'
import Profile from './Profile'
import Resume from './Resume'
import ResumeAdd from './ResumeAdd'
import ResumeSelectionPopup from './ResumeSelectionPopup'
import Tools from './Tools'
import ViewMoreJobs from './ViewMoreJobs'



const CandidateDashbaordRoute = () => {
  return (

    <Routes>
      <Route path="/" element={<CandidateDashboard />} />
       <Route path="*" element={<Error404 />} />
      <Route path='/jobs' element={<CandidateJobs />} />
      <Route path='/companies' element={<CandidatesCompanies />} />
      <Route path='/resume' element={<Resume />} />
      <Route path='/profile' element={<Profile />} />
      <Route path='/payment' element={<Payment />} />
      <Route path='/my-application' element={<MyApplication />} />
      <Route path="/candidate-contact" element={<CandiContact />} />

      <Route path='/resume/resumeAdd' element={<ResumeAdd />} />
      <Route path='/companies/companyPage/companyName/:companyName' element={<CompamyPage />} />
      <Route path='/resumePopUp' element={<ResumeSelectionPopup />} />
      <Route path='/jobs/dream-company/step/:step' element={<DreamCompany />} />
      <Route path='/jobs/dream-job' element={<DreamJob/>}/>
      {/* <Route path='/job-description' element={<JobDescription />}/> */}
      <Route path="/jobs/job-description/:slug" element={<JobDescription />} />

      <Route path='/jobs/job-description/view-more' element={<ViewMoreJobs />}/>
      <Route path='/jobpreference' element={<Jobpreference />}/>
      <Route path='/coming-soon' element={<ComingSoon />} />
      <Route path='/tools' element={<Tools />} />
      <Route path='/jobPreferences' element={<JobPreferences />} />
    </Routes>

  )
}

export default CandidateDashbaordRoute
